import type { ReactNode } from 'react';

import { cn } from '../../lib/utils';

type TreeItemLabelProps = {
  children: ReactNode;
  className?: string;
};

export function TreeItemLabel({ children, className }: TreeItemLabelProps) {
  return (
    <div
      className={cn(
        'eye:min-w-0 eye:text-wrap eye:wrap-break-word',
        className,
      )}
    >
      {children}
    </div>
  );
}
